export default "__VITE_ASSET__xfTN43Cy__"